import { Box, Button, IconButton } from "@mui/material";
import Icon from "@mui/material/Icon";
import { Link } from "react-router-dom";

import ActionMenu from "~/components/ActionMenu";
import BackgroundJobQueueButton from "~/components/backgroundJobs/BackgroundJobQueueButton";
import NotificationBell from "~/components/NotificationBell";
import { useAppSelector } from "~/hooks/reduxHooks";
import InboxButton from "~/layout/InboxButton";

const PageButtons = () => {
	const pageButtons = useAppSelector((state) => state.layout.pageButtons);
	const isWideScreen = useAppSelector((state) => state.layout.isWideScreen);

	return (
		<Box sx={{ display: "flex", flexDirection: "row-reverse", ml: "auto" }}>
			<NotificationBell />
			<BackgroundJobQueueButton />
			<InboxButton />
			{pageButtons?.map((pageBtn: PageButton) =>
				pageBtn.disabled ? null : pageBtn.link ? (
					<Box
						component={Link}
						key={pageBtn.key}
						sx={{ color: "inherit", ml: "0.5rem", textDecoration: "none", whiteSpace: "nowrap" }}
						title={pageBtn.label}
						to={pageBtn.link}
					>
						{pageBtn.iconName ? (
							<IconButton color="inherit">
								<Icon>{pageBtn.iconName}</Icon>
							</IconButton>
						) : (
							<Button
								color={pageBtn.active ? "secondary" : "primary"}
								key={pageBtn.key}
								size="small"
								title={pageBtn.label}
								variant="contained"
							>
								{pageBtn.label}
							</Button>
						)}
					</Box>
				) : pageBtn.label ? (
					<Button
						color={pageBtn.active ? "primary" : "secondary"}
						key={pageBtn.key}
						size="small"
						sx={{ ml: "0.5rem", whiteSpace: "nowrap" }}
						title={pageBtn.label}
						variant="contained"
					>
						{pageBtn.label}
					</Button>
				) : null
			)}
			{!isWideScreen && <ActionMenu />}
		</Box>
	);
};

export default PageButtons;
